import BZAPIService from '../../../services/BZAPIService';
import { createOddLookup, useOddLookup } from './oddLookup';

// Stored version ids are ODD suggestionIds, which can differ from the release
// label the project view shows (Cisco "15.0" vs "15.0(1k)"). Labels are looked
// up once per (vendor, product) after the list renders and cached for the
// session; until then — or when the lookup fails — callers get the raw id.
const labels = createOddLookup(async (vendorId, productId) => {
  const data = await BZAPIService.bsaGetBstSoftwareSuggestions(vendorId, productId);
  const map = new Map();
  ((data && data.results) || []).forEach(row => {
    if (row.suggestionId != null) map.set(String(row.suggestionId), row.releaseVersion || String(row.suggestionId));
  });
  return map;
});

const productArgs = project => (project.vendorId && project.productId ? [project.vendorId, project.productId] : null);

export default function useVersionLabels(projects) {
  const labelsFor = useOddLookup(labels, projects, productArgs);
  return (project, versionId) => {
    if (!versionId) return versionId;
    const map = labelsFor(project);
    return (map && map.get(String(versionId))) || versionId;
  };
}
